<template>
  <v-container class="login-bg fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="login-card py-6 px-4 px-md-8" elevation="10">
          <div class="d-flex flex-column align-center mb-3">
            <img
              :src="logoMilys"
              alt="Mily's Beauty Salon Logo"
              class="login-logo mb-2"
            />
            <div class="text-h5 font-weight-bold login-gold mb-2 text-center">
              <!-- Bienvenido a Mily's Beauty Salon -->
              {{ t('login.title') }}
            </div>
            <div class="text-subtitle-2 login-light mb-4 text-center">
              <!-- Por favor, inicia sesión para continuar -->
              {{ t('login.subtitle') }}
            </div>
          </div>
          <v-form>
            <v-text-field
              :label="t('login.username')"
              v-model="username"
              prepend-icon="mdi-account"
              variant="outlined"
              class="login-input"
              style="color: #d6b16d"
            />
            <v-text-field
              :label="t('login.password')"
              v-model="password"
              type="password"
              prepend-icon="mdi-lock"
              variant="outlined"
              class="login-input"
              style="color: #d6b16d"
            />
            <v-btn
              :loading="loading"
              color="primary"
              class="login-btn mt-4"
              block
              size="large"
              @click="handleLogin"
            >
              <!-- Entrar -->
              {{ t('login.button') }}
            </v-btn>
            <div v-if="error" class="text-center mt-3 login-error">
              {{ error }}
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <!-- Modal obligatorio para cambiar contraseña -->
    <v-dialog v-model="showChangePassword" persistent max-width="400">
      <v-card class="login-card-modal">
        <v-card-title class="text-h6 login-gold">
          <!-- Establece una nueva contraseña -->
          {{ t('login.changePassword') }}
        </v-card-title>
        <v-card-text>
          <div  style="color: white; margin-bottom: 10px;" class="mb-2">
            <!-- Por seguridad, debes cambiar tu contraseña asignada por default. -->
            {{ t('login.changePasswordMsg') }}
          </div>
          <v-form>
            <v-text-field
              v-model="newPassword"
              :label="t('login.newPassword')"
              type="password"
              :rules="[v => !!v || t('login.newPasswordRules')]"
              prepend-icon="mdi-lock"
               style="color: #d6b16d; padding-top: 20px;"
            />
            <v-text-field
              v-model="confirmPassword"
              :label="t('login.confirmPassword')"
              type="password"
              :rules="[v => v === newPassword ||  t('login.confirmPasswordRules')]"
              prepend-icon="mdi-lock"
               style="color: #d6b16d"
            />
          </v-form>
          <div v-if="changeError" class="login-error mt-2">{{ changeError }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="login-btn mt-4" block @click="submitChangePassword">
             <!-- Guardar nueva contraseña -->
            {{ t('login.savePassword') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import logoMilys from "@/assets/logo-milys_peque.png";
import apiClient from "../services/api";
import router from "@/router";
import { useI18n } from 'vue-i18n';
const { t } = useI18n(); 


const authStore = useAuthStore();
const username = ref("");
const password = ref("");
const error = ref(null);
const loading = ref(false);

const showChangePassword = ref(false);
const newPassword = ref("");
const confirmPassword = ref("");
const changeError = ref("");
const userData = ref(null);

async function handleLogin() {
  error.value = null;
  loading.value = true;
  try {
    const valReturn = await authStore.login(username.value, password.value);
    if (valReturn && valReturn.changePassword) {
       // Guardar datos temporalmente y mostrar modal
      userData.value = authStore.user;
      showChangePassword.value = true;
      loading.value = false;
    }
  } catch (e) {
    error.value = e.message;
  } finally {
    loading.value = false;
  }
}
async function submitChangePassword() {
  changeError.value = "";
  // Validaciones
  if (!newPassword.value || !confirmPassword.value) {
    changeError.value = t('login.submitChagePasswordError1');
    return;
  }
  if (newPassword.value !== confirmPassword.value) {
    changeError.value = t('login.submitChagePasswordError2');
    return;
  }
  if (newPassword.value.length < 6) {
    changeError.value = t('login.submitChagePasswordError3');
    return;
  }
  try {
    // Llama al endpoint para cambiar la contraseña
   
    await apiClient.post(`users.php`, {
        id: userData.value.id,
        password: newPassword.value,
        tipo: "password",
      });

      
    alert( t('login.submitChagePasswordSuccess') );
    showChangePassword.value = false;
    router.push("/dashboard");
  } catch (e) {
    changeError.value = t('login.submitChagePasswordError');
    console.error(e);
  }
}
</script>

<style scoped>
/* Fondo general */
.login-bg {
  background: linear-gradient(135deg, #1e1e1e 0%, #232323 100%);
  color: #fff;
  min-height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

/* Tarjeta de login */
.login-card {
  background: #2d2d2d;
  border-radius: 18px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.6);
}
.login-card-modal {
  background: #2d2d2d;
  border-radius: 18px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.6);
}

/* Logo */
.login-logo {
  max-width: 120px;
  width: 90%;
  margin: 0 auto;
  display: block;
}

/* Colores del texto */
.login-gold {
  color: #d6b16d !important;
}
.login-light {
  color: #d3d3d3;
}
.login-error {
  color: #ff6b6b;
  font-size: 0.9rem;
}

/* Campos de entrada */
.login-input .v-field__input,
.login-input input,
.login-input .v-label,
.login-input .v-input__control,
.login-input .v-field__outline,
.login-input .v-icon,
.login-input .v-field__append-inner,
.login-input .v-field__prepend-inner {
  color: #d6b16d !important;
  background: #232323 !important;
  border-color: #444 !important;
}

.login-input .v-field__outline {
  border-color: #444 !important;
}

.login-input .v-label {
  color: #d3d3d3 !important;
}

/* Cambia el color del icono de los inputs */
.login-input .v-field__prepend-inner .v-icon,
.login-input .v-field__append-inner .v-icon {
  color: #d6b16d !important;
}

/* Placeholder color */
.login-input input::placeholder {
  color: #d3d3d3 !important;
  opacity: 1;
}

/* Botón de login */
.login-btn {
  background: linear-gradient(90deg, #d6b16d 0%, #b2935e 100%);
  color: #232323 !important;
  font-weight: bold;
  letter-spacing: 0.5px;
  border-radius: 8px;
}

/* Responsividad */
@media (max-width: 960px) {
  .login-card {
    padding: 2rem 1rem !important;
  }

  .login-card-modal {
    padding: 1rem 1rem !important;
  }
  .login-logo {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 961px) and (max-width: 1280px) {
  .login-card {
    padding: 3rem 2rem !important;
  }
  .login-card-modal {
    padding: 2rem 2rem !important;
  }
}

@media (min-width: 1281px) {
  .login-card {
    padding: 4rem 3rem !important;
  }
  .login-card-modal {
    padding: 2rem 2rem !important;
  }
}
</style>
